export const getCountryCode = (country) => {
    const countries = { 'Sweden': 'se', 'France': 'fr' };
    return countries[country];
}
